import Trellis from "./_js/widget";
import injector from "../_js/injector";

// This is the script that all copy-paste widget-embedding code should link to.
// It reads global widget-config instructions in addition to searching the DOM
// for configs embedded via script-element attributes and builds weather forecast
// widgets for each set of instructions found.
injector(Trellis, 'trellis');
